import React from "react";

const BottomBanner = () => {

    return (

        <div className="bottom-banner">

            <div className="bottom-banner-content">

                <h3>
                    India's Trusted Polymer Marketplace
                </h3>

                <p>
                    Buy and sell plastic raw materials with verified traders across India.
                </p>

            </div>

        </div>

    );

};

export default BottomBanner;